export default __webpack_public_path__ + "static/media/gl-10.ca61bc39.png";